module.exports = __webpack_public_path__ + "img/7-1.e546da2e.jpg";